import 'focus-within-polyfill';

import { UserIsTabbing } from './components/userIsTabbing';
import { Global } from './components/global';
import { Header } from './components/header';
import { Logo } from './components/logo';
import { FeatureMedia } from './components/featureMedia';
import { Animation } from './components/animation';
import { Wayfinder } from './components/wayfinder';
import { TileWall } from './components/tileWall';
import { Accordion } from './components/accordion';
import { Video } from './components/video';
import { TiltAnimation } from './components/tilt';
import { Newsletter } from './components/newsletter';
import { AnimateOnScroll } from './components/aos';
import { Parallax } from './components/parallax';
import { Labels } from './components/labels';
import { LoadMore } from './components/loadMore';

require('svgxuse');

const components = [
    UserIsTabbing,
    Global,
    Header,
    Logo,
    FeatureMedia,
    Animation,
    Wayfinder,
    TileWall,
    Accordion,
    Video,
    TiltAnimation,
    Newsletter,
    AnimateOnScroll,
    Parallax,
    Labels,
    LoadMore
];

document.addEventListener('DOMContentLoaded', () => {
    components.forEach(Component => Component.create());
});
